interface Props {
    beginDate: string;
    endDate: string;
}

export function PersonalAccidentsHiddenInputs({ beginDate, endDate }: Props) {
    return (
        <>
            <input type="hidden" name="beginDate" value={beginDate} />
            <input type="hidden" name="endDate" value={endDate} />
        </>
    );
}
